<div class="mt-5 bg-grey-veryLight rounded-xl p-3">
	<div class="text-sm text-grey-dark">
		<div *ngIf="(userRole$ | async) === businessUserRole.LAWYER">
			<p class="font-bold">Unsure where to find your profile ID?</p>
			<p class="mt-3">
				If you are an existing Stewart Title client, contact Stewart Support at
				<app-anchor
					class="inline whitespace-nowrap"
					url="tel:888-677-5151"
					[external]="true"
					>(888) 667-5151</app-anchor
				>
				or your
				<app-anchor
					class="inline"
					url="http://www.stewart.ca/contactrep"
					[external]="true"
					>Business Development Manager</app-anchor
				>.
			</p>
		</div>
		<div *ngIf="(userRole$ | async) === businessUserRole.CLERK">
			<p class="font-bold">Unsure where to find the profile ID for a lawyer?</p>
			<p class="mt-3">
				If you are an existing Stewart Title client, contact Stewart Support at
				<app-anchor
					class="inline whitespace-nowrap"
					url="tel:888-677-5151"
					[external]="true"
					>(888) 667-5151</app-anchor
				>
				or your
				<app-anchor
					class="inline"
					url="http://www.stewart.ca/contactrep"
					[external]="true"
					>Business Development Manager</app-anchor
				>.
			</p>
		</div>
		<p class="mt-3">
			Not a Stewart Title client? Click
			<app-anchor
				url="https://www.stewart.ca/contact-us/becomeaclient"
				[external]="true"
				class="inline"
				>here</app-anchor
			>
			to sign up.
		</p>
	</div>
</div>
